const config: PageConfigurationType = {
    breadCrumbs: [{ label: 'home', path: 'home' }, 'approved_trikos']
}

export default config
